import { combineReducers } from 'redux'

import { entitiesCreators } from 'store/common'

import * as reducersNames from 'utils/enums/reducersNames'

export const entitiesNames = [reducersNames.REDUCER_NAME_FEEDBACK_FORMS]

export const entitiesReducers = entitiesNames
  .sort()
  .reduce((reducers, name) => ({ ...reducers, [name]: entitiesCreators.createStoreEntity(name) }), {})

export default combineReducers(entitiesReducers)
